<template>
    <div class="content work_wrapper search_content patentInfo_content">
        <v-row class="search_box">
            <v-col>
              <searchBar :searchKey="searchkey"></searchBar>
            </v-col>
        </v-row>
        <div class="detail_content_center" :class="{'from': fromName=='space'}">
            <div class="left_side_wrapper" v-if="fromName!='space'">
                <patentList @detailChange="detailChange" :detailInfo="detailInfo"></patentList>
            </div>
            <div class="right_side_wrapper">
                <div class="detail_content_wrapper">
                    <!-- <div class="back_icon hand padTop" @click="goBack"><v-icon>mdi-chevron-left</v-icon> 返回专利列表</div> -->
                    <div class="back_icon hand padTop" @click="goBack"><v-icon>mdi-chevron-left</v-icon> 返回专利列表</div>

                    <v-row>
                        <v-col sm="12" class="padTop8">
                            <div class="detail_content">
                                <div class="detail_content_top">
                                    <div class="top_left">
                                        <div class="flex_style left">
                                            <div class="tag invent" v-if="detailInfo.type=='发明公开'" >{{detailInfo.type}}</div>
                                            <div class="tag grant" v-if="detailInfo.type=='发明授权'" >{{detailInfo.type}}</div>
                                            <div class="tag unlty" v-if="detailInfo.type=='实用新型'">{{detailInfo.type}}</div>
                                            <div class="tag design" v-if="detailInfo.type=='外观设计'">{{detailInfo.type}}</div>
                                            <div class="text">{{detailInfo.id}}</div>
                                            <div class="tag valid" v-if="detailInfo.legalStatus=='有效专利'">{{detailInfo.legalStatus}}</div>
                                            <div class="tag publish" v-if="detailInfo.legalStatus=='公开'">{{detailInfo.legalStatus}}</div>
                                            <div class="tag szhi" v-if="detailInfo.legalStatus=='实质审查'">{{detailInfo.legalStatus}}</div>
                                            <div class="tag invalid" v-if="detailInfo.legalStatus=='失效专利' || detailInfo.legalStatus=='无效专利'">{{detailInfo.legalStatus}}</div>
                                           
                                        </div>
                                        <div class="name">{{detailInfo.title}}</div>
                                    </div>
                                    <div class="top_right">
                                        <div class="flex_style right">
                                            <div class="menu_icon hand" title="pdf下载">
                                                <span class="icon down"></span>
                                                <span class="text hidden-xs-only" @click="getPdfFile(detailInfo.id)">
                                                    PDF下载
                                                </span>
                                            </div>
                                            <!-- <div class="menu_icon hand" title="pdf查看" @click="pdfView" v-if="src">
                                                <span class="icon view"></span>
                                                <span class="text hidden-xs-only">PDF查看</span>
                                            </div> -->
                                            <div class="menu_icon hand" title="双屏查看" @click="doubleSreen">
                                                <span class="icon screen"></span>
                                                <span class="text hidden-xs-only">双屏查看</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>      
                                <v-tabs :class="{'tab_detail1':true,'custom_style1': !isPhone}" :vertical="vertical" @change="handleChange" v-model="activeKey" show-arrows>
                                    <v-tab key="1"><i class="icon base"></i>基本信息</v-tab>
                                    <v-tab key="2" v-if="false"><i class="icon summary"></i>摘要</v-tab>
                                    <v-tab key="3"><i class="icon rights"></i>权利要求</v-tab>
                                    <v-tab key="4"><i class="icon desp"></i>说明书</v-tab>
                                    <v-tab key="5"><i class="icon fivepdf"></i>PDF全文</v-tab>
                                    <v-tab key="6"><i class="icon fimg"></i>附图</v-tab>
                                    <v-tab key="7"><i class="icon case"></i>案件信息</v-tab>
                                    <v-tab key="8"><i class="icon law"></i>法律信息</v-tab>
                                    <div class="line_gap"></div>
                                    <v-tab key="9"><i class="icon cite"></i>引用信息</v-tab>
                                    <v-tab key="10"><i class="icon family"></i>同族专利</v-tab>
                                    <v-tab key="11"><i class="icon like"></i>相似专利</v-tab>
                                    <v-tab-item key="1">
                                       <pantentBase :pid='pid' ></pantentBase>
                                    </v-tab-item>
                                    <v-tab-item key="2" v-if="false">
                                        <div class="tabs_content baseInfo">
                                            <!-- <div class="title1">专利摘要</div> -->
                                            <v-row>
                                                <v-col sm="12" v-if="detailInfo.summary">
                                                    <div v-for="(item,index) in detailInfo.summary.split('。')" :key="index">
                                                        <p v-if="item">{{item}}。</p>
                                                    </div>
                                                </v-col>
                                                <v-col sm="12" v-else>
                                                    <span>暂无数据</span>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </v-tab-item>
                                    <v-tab-item key="3">
                                        <claim :pid='pid'></claim>
                                    </v-tab-item>
                                    <!----PDF全文---->
                                        <v-tab-item key="4">
                                        <direction :pid='pid'></direction>
                                    </v-tab-item>
                                    <!----->
                                      <v-tab-item key="5">
                                        <div class="pdf_wrapper">
                                            <v-card>
                                            <!-- <v-card-title
                                                >PDF全文
                                                <v-icon @click="visible = false">mdi-close</v-icon>
                                            </v-card-title> -->
                                            <v-card-text>
                                            <div style="height: 100%">
                                            <embed
                                                :src="src"
                                                type="application/pdf"
                                                width="100%"
                                                height="100%"
                                            />
                                            </div>
                                        </v-card-text>
                                        <v-divider></v-divider>
                                        </v-card>
                                      </div>
                                            


                                       
                                    </v-tab-item>
                                    <v-tab-item key="6">
                                         <patentImage :pid='pid'></patentImage>   
                                    </v-tab-item>
                                    <v-tab-item key="7">
                                       <caseInfo :pid="pid"></caseInfo>
                                    </v-tab-item>
                                    <v-tab-item key="8">
                                       
                                        <law :pid='pid'></law>
                                    </v-tab-item>
                                    <v-tab-item key="9">
                                        <div class="tabs_content baseInfo">
                                            <!-- <div class="title1">专利引用信息</div> -->
                                            <v-tabs show-arrows>
                                                <v-tab key="1">引用、被引用列表</v-tab>
                                                <v-tab key="2">被引用关系图</v-tab>
                                                <v-tab key="3">引用关系图</v-tab>
                                                <v-tab-item key="1">
                                                    <div class="tabs_content1 detail_table">
                                                        <h3 class="margbsm">被引用列表</h3>
                                                        <v-data-table
                                                            item-key="id"
                                                            :headers="headers"
                                                            :items="citedList"
                                                            :loading="loading3"
                                                            class="elevation-1"
                                                            @click:row="goDetail"
                                                            :items-per-page='20'
                                                            :footer-props="{
                                                                itemsPerPageAllText: '全部',
                                                                itemsPerPageText: '每页',
                                                                showCurrentPage: true,
                                                                itemsPerPageOptions: [5,10,15,20,-1],
                                                            }"
                                                        >
                                                        </v-data-table>
                                                        <h3 class="margbsm margtsm">引用列表</h3>
                                                        <v-data-table
                                                            item-key="id"
                                                            :headers="headers"
                                                            :items="citingList"
                                                            :loading="loading3"
                                                            class="elevation-2"
                                                            @click:row="goDetail"
                                                            :items-per-page='20'
                                                            :footer-props="{
                                                                itemsPerPageAllText: '全部',
                                                                itemsPerPageText: '每页',
                                                                showCurrentPage: true,
                                                                itemsPerPageOptions: [5,10,15,20,-1],
                                                            }"
                                                        >
                                                        </v-data-table>
                                                    </div>
                                                </v-tab-item>
                                                <v-tab-item key="2">
                                                    <div class="tabs_content1">
                                                        <tree1 :data="citedTree" v-if="citedTree"></tree1>
                                                        <div v-else>该专利没有被引用数据</div>
                                                    </div>
                                                </v-tab-item>
                                                <v-tab-item key="3">
                                                    <div class="tabs_content1">
                                                        <tree :data="citingTree" v-if="citingTree"></tree>
                                                        <div v-else>该专利没有引用数据</div>
                                                    </div>
                                                </v-tab-item>
                                            </v-tabs>
                                        </div>
                                    </v-tab-item>
                                    <v-tab-item key="10">
                                        <div class="tabs_content baseInfo">
                                            <!-- <div class="title1">专利同族信息</div> -->
                                            <v-tabs show-arrows>
                                                <v-tab key="1">基本同族</v-tab>
                                                <v-tab key="2">拓展同族</v-tab>
                                                <v-tab-item key='1'>
                                                    <div class="tabs_content1 detail_table">
                                                        <v-data-table
                                                            item-key="id"
                                                            :headers="headers"
                                                            :items="familyList"
                                                            :loading="loading4"
                                                            class="elevation-1"
                                                            @click:row="goDetail"
                                                            :items-per-page='20'
                                                            :footer-props="{
                                                                itemsPerPageAllText: '全部',
                                                                itemsPerPageText: '每页',
                                                                showCurrentPage: true,
                                                                itemsPerPageOptions: [5,10,15,20,-1],
                                                            }"
                                                        >
                                                        </v-data-table>
                                                        <world :info="worldInfo" v-if="worldInfo&&worldInfo.id"></world>
                                                    </div>
                                                </v-tab-item>
                                                <v-tab-item key='2'>
                                                    <div class="tabs_content1 detail_table">
                                                        <v-data-table
                                                            item-key="id"
                                                            :headers="headers"
                                                            :items="extendedFamily"
                                                            :loading="loading4"
                                                            class="elevation-2"
                                                            @click:row="goDetail"
                                                            :items-per-page='20'
                                                            :footer-props="{
                                                                itemsPerPageAllText: '全部',
                                                                itemsPerPageText: '每页',
                                                                showCurrentPage: true,
                                                                itemsPerPageOptions: [5,10,15,20,-1],
                                                            }"
                                                        >
                                                        </v-data-table>
                                                        <world1 :info="worldInfo1" v-if="worldInfo1&&worldInfo1.id"></world1>
                                                    </div>
                                                </v-tab-item>
                                            </v-tabs>
                                        
                                        </div>
                                    </v-tab-item>
                                    <v-tab-item key="11">
                                        <div class="tabs_content baseInfo detail_table">
                                            <!-- <div class="title1">专利相似信息</div> -->
                                            <v-data-table
                                                item-key="id"
                                                :headers="headers"
                                                :items="likeList"
                                                :loading="loading5"
                                                class="elevation-1"
                                                @click:row="goDetail"
                                                :items-per-page='20'
                                                :footer-props="{
                                                    itemsPerPageAllText: '全部',
                                                    itemsPerPageText: '每页',
                                                    showCurrentPage: true,
                                                    itemsPerPageOptions: [5,10,15,20,-1],
                                                }"
                                            >
                                            
                                            </v-data-table>
                                        </div>
                                    </v-tab-item>
                                </v-tabs>
                            </div>
                        </v-col>
                    <!-- <v-col sm="10"></v-col> -->
                    </v-row>
                </div>
            </div>
        </div>
        <v-dialog v-model="visible" width="80%">
            <div class="pdf_wrapper">
                <!-- <div class="tit">PDF全文</div> -->
                <v-card>
                    <v-card-title>PDF全文 <v-icon @click="visible=false">mdi-close</v-icon></v-card-title>
                    <v-card-text>
                        <div style="height: 100%;">
                            <embed
                                :src="src"
                                type="application/pdf"
                                width="100%"
                                height="100%"
                                />
                        </div>
                        <!-- <pdf v-for="i in pageCount" :key="i" :page="i" :src="src"></pdf> -->
                    </v-card-text>
                    <v-divider></v-divider>
                </v-card>
            </div>
        </v-dialog>
        <v-dialog v-model="visible1" width="90%" :fullscreen="fullscreen">
            <v-card class="compare_dialog">
                <div class="flex_style right padsm">
                    <v-icon v-if="!fullscreen" @click="fullscreen=true">mdi-fullscreen</v-icon>
                    <v-icon v-if="fullscreen" @click="fullscreen=false">mdi-fullscreen-exit</v-icon>
                    <v-icon class="marl10" @click="visible1= false">mdi-close</v-icon>
                </div>
                <v-card-text class="full">
                    <v-row>
                        <v-col sm="6" class="border-right">
                            <v-row class="detail_content1 common_tabs">
                                <v-col sm="12" class="detail_col">
                                        <v-tabs :show-arrows="true" @change="handleChange1">
                                            <v-tab key="1" @click="getDetail(this.id)">基本信息</v-tab>
                                            <v-tab key="2">摘要</v-tab>
                                            <v-tab key="3" >权利要求</v-tab>
                                            <v-tab key="4">说明书</v-tab>
                                            <v-tab key="5">PDF全文</v-tab>
                                            <v-tab key="7">法律信息</v-tab>
                                            <v-tab-item key="1">
                                                <div class="tabs_content left">
                                                    <h3 class="margbsm">专利基本信息</h3>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">申请号</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.applicationNumber}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">申请日</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.applicationDate}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">公开（公告）号</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.documentNumber}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">公开（公告）日</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.documentDate}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">授权日</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.applicationNumber}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">当前申请（专利权）人</v-col>
                                                        <v-col formLayout.wrapperCol>
                                                            <span v-for="(item,index) in detailInfo.applicant" :key="index">
                                                                {{item}}
                                                            </span>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">第一申请（专利权）人</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.firstApplicant}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">发明人</v-col>
                                                        <v-col formLayout.wrapperCol>
                                                            <span v-for="(item,index) in detailInfo.inventor" :key="index">
                                                                {{item}}
                                                            </span>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">第一发明人</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.firstInventor}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">IPC分类号</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.mainIpc}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">申请地址</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.applicantAddress}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">代理人</v-col>
                                                        <v-col formLayout.wrapperCol>
                                                            <span v-for="(item,index) in detailInfo.agent" :key="index">
                                                                {{item}}
                                                            </span>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">代理机构</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.agency}}</v-col>
                                                    </v-row>
                                                    <v-row v-if="false">
                                                        <v-col sm="3">摘要</v-col>
                                                        <v-col sm="9">{{detailInfo.summary}}</v-col>
                                                    </v-row>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="2">
                                                <div class="tabs_content left">
                                                    <h3 class="margbsm">专利摘要</h3>
                                                    <v-row>
                                                        <v-col sm="12" v-if="detailInfo.summary">
                                                            <div v-for="(item,index) in detailInfo.summary.split('。')" :key="index">
                                                                <p v-if="item">{{item}}。</p>
                                                            </div>
                                                        </v-col>
                                                        <v-col sm="12" v-else>
                                                            <span>暂无数据</span>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="3">
                                               
                                                <div class="tabs_content left" v-if="claimsInfo">

                                                    <h3 class="margbsm">专利权利要求书</h3>
                                                    <div v-for="(item,index) in claimsInfo.split('。')" :key="index">
                                                        <p v-if="item">{{item}}。</p>
                                                    </div>
                                                </div>
                                                <div class="tabs_content" v-else>
                                                    <span>暂无数据</span>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="4">
                                                <div class="tabs_content left" v-if="despInfo">
                                                    <h3 class="margbsm">专利说明书</h3>
                                                    <div v-for="(item,index) in despInfo.split('。')" :key="index">
                                                        <p v-if="item">{{item}}。</p>
                                                    </div>
                                                </div>
                                                <div class="tabs_content" v-else>
                                                    <span>暂无数据</span>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="5">
                                                <div class="tabs_content left">
                                                    <div style="height: 100%;">
                                                        <embed
                                                            :src="src"
                                                            type="application/pdf"
                                                            width="100%"
                                                            height="100%"
                                                            />
                                                    </div>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="7">
                                                <div class="tabs_content left">
                                                    <v-data-table
                                                        item-key="id"
                                                        :headers="transHeader"
                                                        :items="transList"
                                                        :loading="loading"
                                                        class="elevation-1"
                                                    >
                                                    </v-data-table>
                                                </div>
                                            </v-tab-item>
                                        </v-tabs>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col sm="6">
                            <v-row class="detail_content1 right common_tabs">
                                <v-col sm="12" class="detail_col">
                                        <v-tabs :show-arrows="true" @change="handleChange1">
                                            <v-tab key="1" @click="getDetail(this.id)">基本信息</v-tab>
                                            <v-tab key="2">摘要</v-tab>
                                            <v-tab key="3" >权利要求</v-tab>
                                            <v-tab key="4">说明书</v-tab>
                                            <v-tab key="5">PDF全文</v-tab>
                                            <v-tab key="7">法律信息</v-tab>
                                            <v-tab-item key="1">
                                                <div class="tabs_content right">
                                                    <h3 class="margbsm">专利基本信息</h3>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">申请号</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.applicationNumber}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">申请日</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.applicationDate}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">公开（公告）号</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.documentNumber}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">公开（公告）日</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.documentDate}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">授权日</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.applicationNumber}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">当前申请（专利权）人</v-col>
                                                        <v-col formLayout.wrapperCol>
                                                            <span v-for="(item,index) in detailInfo.applicant" :key="index">
                                                                {{item}}
                                                            </span>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">第一申请（专利权）人</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.firstApplicant}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">发明人</v-col>
                                                        <v-col formLayout.wrapperCol>
                                                            <span v-for="(item,index) in detailInfo.inventor" :key="index">
                                                                {{item}}
                                                            </span>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">第一发明人</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.firstInventor}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">IPC分类号</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.mainIpc}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">申请地址</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.applicantAddress}}</v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">代理人</v-col>
                                                        <v-col formLayout.wrapperCol>
                                                            <span v-for="(item,index) in detailInfo.agent" :key="index">
                                                                {{item}}
                                                            </span>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col formLayout.labelCol class="label">代理机构</v-col>
                                                        <v-col formLayout.wrapperCol>{{detailInfo.agency}}</v-col>
                                                    </v-row>
                                                    <v-row v-if="false">
                                                        <v-col sm="3">摘要</v-col>
                                                        <v-col sm="9">{{detailInfo.summary}}</v-col>
                                                    </v-row>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="2">
                                                <div class="tabs_content right">
                                                    <h3 class="margbsm">专利摘要</h3>
                                                    <v-row>
                                                        <v-col sm="12" v-if="detailInfo.summary">
                                                            <div v-for="(item,index) in detailInfo.summary.split('。')" :key="index">
                                                                <p v-if="item">{{item}}。</p>
                                                            </div>
                                                        </v-col>
                                                        <v-col sm="12" v-else>
                                                            <span>暂无数据</span>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="3">
                                                <div class="tabs_content right" v-if="claimsInfo">
                                                    <h3 class="margbsm">专利权利要求书</h3>
                                                    委屈翁
                                                    <div v-for="(item,index) in claimsInfo.split('。')" :key="index">
                                                        <p v-if="item">{{item}}。</p>
                                                    </div>
                                                </div>
                                                <div class="tabs_content" v-else>
                                                    <span>暂无数据</span>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="4">
                                                <div class="tabs_content right" v-if="despInfo">
                                                    <h3 class="margbsm">专利说明书</h3>
                                                    <div v-for="(item,index) in despInfo.split('。')" :key="index">
                                                        <p v-if="item">{{item}}。</p>
                                                    </div>
                                                </div>
                                                <div class="tabs_content" v-else>
                                                    <span>暂无数据</span>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="5">
                                                <div class="tabs_content left">
                                                    <div style="height: 100%;">
                                                        <embed
                                                            :src="src"
                                                            type="application/pdf"
                                                            width="100%"
                                                            height="100%"
                                                            />
                                                    </div>
                                                </div>
                                            </v-tab-item>
                                            <v-tab-item key="7">
                                                <div class="tabs_content left">
                                                    <v-data-table
                                                        item-key="id"
                                                        :headers="transHeader"
                                                        :items="transList"
                                                        :loading="loading"
                                                        class="elevation-1"
                                                    >
                                                    </v-data-table>
                                                </div>
                                            </v-tab-item>
                                        </v-tabs>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="imgVisible" width="90%">
            <div>
                <v-img :src="$store.state.baseUrl + detailInfo.bigImagePath"></v-img>
            </div>
        </v-dialog>
    </div>
</template>
<script>
import mix from '../search/pantentInfo/mix.js'
import searchBar from "@/components/widgets/searchBar.vue";
import tree from "@/components/widgets/tree.vue";
import tree1 from "@/components/widgets/tree.vue";
import world from '@/components/widgets/worldMap.vue'
import world1 from '@/components/widgets/worldMap.vue'
import patentList from '@/components/side/patentList.vue'
import {mapActions} from 'vuex'
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
import pdf from 'vue-pdf'
const formLayout = {
    labelCol: { span: 6,md:4,lg:2 },
    wrapperCol: { span:6,md:8,lg:10},
};
export default {
    mixins:[mix],
    data() {
        return {
            pid:{
                id:''
            },
             model: "",
             searchkey:'',
            fullscreen: false,
            formLayout,
            activeKey: '1',
            loading: false,
            vertical: false,
            isPhone: false,
            id: '',
            detailInfo: {},
            claimsInfo: '',
            despInfo: '',
            imgList: [],
            viewer: '',
            visible: false,
            visible1: false,
            imgVisible: false,
            currentPage: 0,
            pageCount: 0,
            likeList: [],
            loading5: false,
            familyList: [],
            loading4: false,
            extendedFamily: [],
            citingList: [],
            citedList: [],
            loading3: false,
            citedTree: '',
            citingTree: '',
            transList: [],
            lawList: [],
            loading2: false,
            fsList: [],
            loading1: false,
            worldInfo: {},
            worldInfo1: {},
            headers: [
                {
                    text: '公开（公告）号',
                    align: 'start',
                    sortable: false,
                    value: 'applicationNumber'
                },
                {
                    text: '标题',
                    align: 'start',
                    sortable: false,
                    value: 'title'
                },
                {
                    text: '发明人',
                    align: 'start',
                    sortable: false,
                    value: 'inventor'
                },
                {
                    text: '申请日',
                    align: 'start',
                    sortable: false,
                    value: 'applicationDate'
                },
                {
                    text: '法律状态/事件',
                    align: 'start',
                    sortable: false,
                    value: 'legalStatus'
                },
                {
                    text: '当前申请（专利权）人',
                    align: 'start',
                    sortable: false,
                    value: 'applicant'
                }
            ],
            transHeader: [
                {
                    text: '执行时间',
                    align: 'start',
                    sortable: false,
                    width:"150",
                    value: 'executeDate'
                },
                {
                    text: '类型',
                    align: 'start',
                    sortable: false,
                    width:"180",
                    value: 'type'
                },
                {
                    text: '内容',
                    align: 'start',
                    sortable: false,
                    value: 'content'
                },
            ],
            lawHeader: [
                {
                    text: '决定号',
                    align: 'start',
                    sortable: false,
                    value: 'decisionNumber'
                },
                {
                    text: '决定日',
                    align: 'start',
                    sortable: false,
                    value: 'decisionDate'
                },
                {
                    text: '委内编号',
                    align: 'start',
                    sortable: false,
                    value: 'number'
                },
                {
                    text: '审定公告日',
                    align: 'start',
                    sortable: false,
                    value: 'applicationDate'
                },
                {
                    text: '复审请求人',
                    align: 'start',
                    sortable: false,
                    value: 'fsPerson'
                },
                {
                    text: '合议组组长',
                    align: 'start',
                    sortable: false,
                    value: 'teamLeader'
                },
                {
                    text: '主审员',
                    align: 'start',
                    sortable: false,
                    value: 'primaryExaminer'
                },
                {
                    text: '参审员',
                    align: 'start',
                    sortable: false,
                    value: 'attendExaminer'
                },
                {
                    text: '操作',
                    align: 'start',
                    sortable: false,
                    value: 'data-table-expand'
                }
            ],
            src: '',
            src1: '',
            fromName: '',
            detailInfo1: {}
        }
    },
    created(){
         let searchkey =sessionStorage.getItem('searchKey')
         console.log(this.$store.state.searchKey)
         console.log(searchkey)
         this.model =searchkey
         console.log(this.detailInfo.applicant)
    },
    mounted() {
        this.$store.commit('setMenuMini', false)
        this.id = this.$route.params.id
        this.pid.id =this.id
        console.log(this.id)
        this.fromName = this.$route.query.from
        this.getDetail(this.id)
        this.getPdf()
        if(this.$route.query&&this.$route.query.tab) {
            if(this.$route.query.tab == 'like') {
                this.activeKey = 8
                this.handleChange(this.activeKey)
            }  
        }
        if(this.$vuetify.breakpoint.name=='sm' || this.$vuetify.breakpoint.name == 'xs') {
            this.vertical = false
            this.isPhone = true
        }
    },
    computed: {
       
        // count() {
        //     return this.$store.state.loadingCount
        // }
    },
    watch: {
        imgList(val) {
            if(val.length>0) {
                this.initImg()
            }
        },
        // count(val) {
        //     if(val <= 0) {
        //         this.loading = false
        //     }else {
        //         this.loading = true
        //     }
        // }
    },
    components: {
        searchBar,
        pdf,
        tree,
        tree1,
        world,
        world1,
        patentList
    },
    methods: {
        ...mapActions('search',['getPatentInfo','getPatentClaims','getPatentDesp','getPatentDraw','getPatentLike','getPatentPdf',
        'getPatentFamily','getPatentExtendedFamily','getPatentCiting','getPatentTransAction','getPatentLaw','createPdfFile',
        'getPdfDown']),
        // goBack() {
        //         this.$route.go()
        // },
        goBack() {
             console.log(this.detailInfo.applicant)
      this.$router.push({
        path: "/search/result",
        query: {
          str: this.model
        },
      });
        },
        handleChange(val) {
            console.log(val)
            if(val ==1 ) {
                this.pid.id =this.id
                this.getClaims()
                
            }
            if(val ==2 && !this.despInfo) {
                this.pid.id =this.id
                this.getDesp()
            }
            if(val ==3) {
                this.pid.id =this.id
                this.getImage()
            }
            if(val ==4) {
                this.pid.id =this.id
                 this.getImage()
                this.getLaw()
            }
            if(val ==5 ) {
                this.pid.id =this.id
                this.getTransAction()
            }
            if(val ==6 ) {
                this.pid.id =this.id
                

                this.getCiting()
            }
            if(val ==7 ) {
                this.pid.id =this.id
                 this.getCiting()
                this.getFamily()
            }
            if(val ==8 ) {
                    this.getCiting()
                
                this.getLike()
            }
            if(this.$route.query.tab&&this.$route.query.tab == 'like') {
                this.$router.replace('')
            }
        },
        handleChange1(val) {
            if(val ==2 && !this.claimsInfo) {
                this.getClaims()
            }
            if(val ==3 && !this.despInfo) {
                this.getDesp()
            }
            if(val ==4 && this.imgList&&this.imgList.length<=0) {
                this.getImage()
            }
            if(val ==5 && this.transList&&this.transList.length<=0) {
                this.getTransAction()
            }
        },
        detailChange(id) {
            this.id = id
            this.activeKey = '1'
            this.getDetail(id)
            this.pid.id =this.id
        },
        getDetail(val) {
             let data = {
                params: {
                    udn: val
                }
            }
            // console.log(data)
            let _this = this
            this.getPatentInfo({data: data,handle(res) {
                    _this.detailInfo1 = res
                    // console.log(res)
                    let info = res.patent ? res.patent: {}
                    _this.detailInfo = info
            }})
            this.pid.id =this.id
       
        },
        getClaims() {
           
            this.loading = true
            this.claimsInfo = ''
            let data = {
                params: {
                   udn: this.id 
                }
            }
            let _this = this
            this.getPatentClaims({data: data,handle(res) {
                console.log(res)

                _this.claimsInfo = res.patent.claims
                _this.loading = false
            }})
        },
        getDesp() {
            this.loading = true
            this.despInfo = ''
            let data = {
                params: {
                   udn: this.id 
                }
            }
            let _this = this
            this.getPatentDesp({data: data,handle(res) {
                _this.despInfo = res.patent.description
                _this.loading = false
            }})
        },
        getImage() {
            this.loading = true
            this.imgList = []
            let data = {
                params: {
                   udn: this.id 
                }
            }
            let _this = this
            this.getPatentDraw({data: data,handle(res) {
                console.log(res,200000000000)
                _this.imgList = res.patent&&res.patent.drawings || []
                _this.loading = false
            }})
        },
        initImg() {
            this.viewer = new Viewer(document.getElementById('image'), {
                inline: false,
                viewed() {
                    this.viewer.zoomTo(1);
                },
            });
        },
        updateImg() {
            this.viewer.update();
        },
        pdfView() {
            this.visible = true
            // window.open(this.src)
        },
        loadPdfHandler (e) {
            this.currentPage = 1 
        },
        getLike() {
            this.loading5 = true
            let data = {
                params: {
                   udn: this.id 
                }
            }
            let _this = this
            this.getPatentLike({data: data,handle(res) {
                _this.likeList = res.patents
                _this.loading5 = false
            }}) 
        },
        getPdf() {
            let data = {
                params: {
                   udn: this.id 
                }
            }
            let _this = this
            this.getPatentPdf({data: data,handle(res) {
                _this.src1 = res.pdf.pdfPath
                _this.src = _this.$store.state.baseUrl + res.pdf.pdfPath
            }})
        },
        getFamily() {
            this.loading4 = true
            let data = {
                params: {
                   udn: this.id 
                }
            }
            let _this = this
            this.getPatentFamily({data: data,handle(res) {
                _this.loading4 = false
                _this.familyList = res.familyPatents.data
                _this.worldInfo = {
                    'familyType': res.familyType,
                    'id': res.patent.id
                }
            }}) 
            this.getPatentExtendedFamily({data: data,handle(res) {
                _this.loading4 = false
                _this.extendedFamily = res.familyPatents.data
                _this.worldInfo1 = {
                    'familyType': res.familyType,
                    'id': res.patent.id
                }
            }})
        },
        getCiting() {
           
            this.loading3 = true
            let data = {
                params: {
                   udn: this.id 
                }
            }
            let _this = this
            this.getPatentCiting({data: data,handle(res) {
                _this.loading3 = false
                _this.citingList = res.listCiting
                _this.citedList = res.listCited
                _this.citedTree = res.tree
                _this.citingTree = res.citingTree
            }})
        },
        getTransAction() {
            this.loading2 = true
            let data = {
                params: {
                   udn: this.id 
                }
            }
            let _this = this
            this.getPatentTransAction({data: data,handle(res) {
                _this.loading2 = false
                _this.transList = res.txs
            }})
        },
        getLaw() {
            this.loading1 = true
            let data = {
                params: {
                   udn: this.id 
                }
            }
            let _this = this
            this.getPatentLaw({data: data,handle(res) {
                _this.loading1 = false
                _this.lawList = res.lawList
                _this.fsList = res.fsList
            }})
        },
        goDetail(val,items) {
            let id = items.item.id
            this.activeKey = '1'
            this.getDetail(id)
            this.getPdf()
            let routeUrl = this.$router.resolve({
                path: '/search/patentInfo/'+ id,
            })
            window.open(routeUrl.href, '_blank');
        },
        doubleSreen() {
            this.visible1 = true
        },
        showImg() {
            this.imgVisible = true
        },
        getPdfFile(val) {
            let data = {
                url: val,
                data1: {
                    params: {
                        t: 0
                    }
                }
            }
            let _this = this
            this.getPdfDown({data: data,handle(res) {
                let fp = res.fp
                window.location.href = _this.$store.state.baseUrl + '/export/download?path='+ fp
            }})
        },
        goSearch(name,val) {
            let str = ''
            if(name == 'key') {
                str = val
            }else {
                str = name+':'+val
            }
            let routeUrl = this.$router.resolve({
                path: '/search/result',
                query: {
                    str: str,
                },
            })
            window.open(routeUrl.href, '_blank');
        }
    }
}
</script>